import { render, staticRenderFns } from "./NsHeaderMid.vue?vue&type=template&id=72aaf1c8&scoped=true"
import script from "./NsHeaderMid.vue?vue&type=script&lang=js"
export * from "./NsHeaderMid.vue?vue&type=script&lang=js"
import style0 from "./NsHeaderMid.vue?vue&type=style&index=0&id=72aaf1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aaf1c8",
  null
  
)

export default component.exports